/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "AccessControlBadConfirmation",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        name: "AccessControlEnforcedDefaultAdminDelay",
        type: "error",
    },
    {
        inputs: [],
        name: "AccessControlEnforcedDefaultAdminRules",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
        ],
        name: "AccessControlInvalidDefaultAdmin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "neededRole",
                type: "bytes32",
            },
        ],
        name: "AccessControlUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "allowance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientAllowance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address",
            },
        ],
        name: "ERC20InvalidApprover",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "ERC20InvalidReceiver",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSpender",
        type: "error",
    },
    {
        inputs: [],
        name: "EnforcedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpectedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "functionName",
                type: "string",
            },
        ],
        name: "Forbidden",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "InvalidRoleAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "bits",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "SafeCastOverflowedUintDowncast",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminDelayChangeCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "effectSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminDelayChangeScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminTransferCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "acceptSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminTransferScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "initialAdmin",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "trinityPoolContract",
                type: "address",
            },
        ],
        name: "XUnityInitialized",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "TRINITY_POOL_SMART_CONTRACT_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "beginDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burnFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
        ],
        name: "changeDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelayIncreaseWait",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialAdmin",
                type: "address",
            },
            {
                internalType: "address",
                name: "trinityPoolContract",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollbackDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "0x60a06040523060805234801561001457600080fd5b5061001d610022565b6100d4565b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a00805468010000000000000000900460ff16156100725760405163f92ee8a960e01b815260040160405180910390fd5b80546001600160401b03908116146100d15780546001600160401b0319166001600160401b0390811782556040519081527fc7f505b2f371ae2175ee4913f4499e1f2633a7b5936321eed1cdaeb6115181d29060200160405180910390a15b50565b60805161251b6100fd600039600081816111ed015281816112160152611392015261251b6000f3fe6080604052600436106102255760003560e01c8063634e93da11610123578063a1eda53c116100ab578063cefc14291161006f578063cefc142914610681578063cf6eefb714610696578063d547741f146106d1578063d602b9fd146106f1578063dd62ed3e1461070657600080fd5b8063a1eda53c146105d2578063a217fddf14610606578063a9059cbb1461061b578063ad3cb1cc1461063b578063cc8463c81461066c57600080fd5b80638456cb59116100f25780638456cb591461054657806384ef8ffc1461055b5780638da5cb5b1461058857806391d148541461059d57806395d89b41146105bd57600080fd5b8063634e93da146104a3578063649a5ec7146104c357806370a08231146104e357806379cc67901461052657600080fd5b80632f2ff15d116101b157806342966c681161017557806342966c6814610416578063485cc955146104365780634f1ef2861461045657806352d1902d146104695780635c975abb1461047e57600080fd5b80632f2ff15d14610385578063313ce567146103a557806336568abe146103c15780633f4ba83a146103e157806340c10f19146103f657600080fd5b8063095ea7b3116101f8578063095ea7b3146102da5780630aa6220b146102fa57806318160ddd1461031157806323b872dd14610345578063248a9ca31461036557600080fd5b806301ffc9a71461022a578063022d63fb1461025f5780630307a0dd1461028857806306fdde03146102b8575b600080fd5b34801561023657600080fd5b5061024a610245366004611f95565b610726565b60405190151581526020015b60405180910390f35b34801561026b57600080fd5b50620697805b60405165ffffffffffff9091168152602001610256565b34801561029457600080fd5b506102aa6000805160206124c683398151915281565b604051908152602001610256565b3480156102c457600080fd5b506102cd610737565b6040516102569190611fe3565b3480156102e657600080fd5b5061024a6102f5366004612032565b6107fa565b34801561030657600080fd5b5061030f610812565b005b34801561031d57600080fd5b507f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace02546102aa565b34801561035157600080fd5b5061024a61036036600461205c565b610828565b34801561037157600080fd5b506102aa610380366004612099565b61084e565b34801561039157600080fd5b5061030f6103a03660046120b2565b610870565b3480156103b157600080fd5b5060405160128152602001610256565b3480156103cd57600080fd5b5061030f6103dc3660046120b2565b61089c565b3480156103ed57600080fd5b5061030f610965565b34801561040257600080fd5b5061030f610411366004612032565b610978565b34801561042257600080fd5b5061030f610431366004612099565b61099a565b34801561044257600080fd5b5061030f6104513660046120de565b6109cc565b61030f61046436600461211e565b610bd0565b34801561047557600080fd5b506102aa610beb565b34801561048a57600080fd5b506000805160206124868339815191525460ff1661024a565b3480156104af57600080fd5b5061030f6104be3660046121e8565b610c08565b3480156104cf57600080fd5b5061030f6104de366004612203565b610c1c565b3480156104ef57600080fd5b506102aa6104fe3660046121e8565b6001600160a01b03166000908152600080516020612406833981519152602052604090205490565b34801561053257600080fd5b5061030f610541366004612032565b610c30565b34801561055257600080fd5b5061030f610c52565b34801561056757600080fd5b50610570610c65565b6040516001600160a01b039091168152602001610256565b34801561059457600080fd5b50610570610c81565b3480156105a957600080fd5b5061024a6105b83660046120b2565b610c90565b3480156105c957600080fd5b506102cd610cc8565b3480156105de57600080fd5b506105e7610d07565b6040805165ffffffffffff938416815292909116602083015201610256565b34801561061257600080fd5b506102aa600081565b34801561062757600080fd5b5061024a610636366004612032565b610d7a565b34801561064757600080fd5b506102cd604051806040016040528060058152602001640352e302e360dc1b81525081565b34801561067857600080fd5b50610271610d88565b34801561068d57600080fd5b5061030f610e06565b3480156106a257600080fd5b506106ab610e46565b604080516001600160a01b03909316835265ffffffffffff909116602083015201610256565b3480156106dd57600080fd5b5061030f6106ec3660046120b2565b610e74565b3480156106fd57600080fd5b5061030f610e9c565b34801561071257600080fd5b506102aa6107213660046120de565b610eaf565b600061073182610ef9565b92915050565b7f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace038054606091600080516020612406833981519152916107769061222b565b80601f01602080910402602001604051908101604052809291908181526020018280546107a29061222b565b80156107ef5780601f106107c4576101008083540402835291602001916107ef565b820191906000526020600020905b8154815290600101906020018083116107d257829003601f168201915b505050505091505090565b600033610808818585610f1e565b5060019392505050565b600061081d81610f2b565b610825610f35565b50565b600033610836858285610f42565b610841858585610fa9565b60019150505b9392505050565b6000908152600080516020612466833981519152602052604090206001015490565b8161088e57604051631fe1e13d60e11b815260040160405180910390fd5b6108988282611008565b5050565b600080516020612446833981519152821580156108d157506108bc610c65565b6001600160a01b0316826001600160a01b0316145b15610956576000806108e1610e46565b90925090506001600160a01b038216151580610903575065ffffffffffff8116155b8061091657504265ffffffffffff821610155b15610943576040516319ca5ebb60e01b815265ffffffffffff821660048201526024015b60405180910390fd5b5050805465ffffffffffff60a01b191681555b6109608383611024565b505050565b600061097081610f2b565b610825611057565b6000805160206124c683398151915261099081610f2b565b61096083836110b7565b60405163d5efc6bb60e01b815260040161093a90602080825260049082015263313ab93760e11b604082015260600190565b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a008054600160401b810460ff16159067ffffffffffffffff16600081158015610a125750825b905060008267ffffffffffffffff166001148015610a2f5750303b155b905081158015610a3d575080155b15610a5b5760405163f92ee8a960e01b815260040160405180910390fd5b845467ffffffffffffffff191660011785558315610a8557845460ff60401b1916600160401b1785555b6001600160a01b038616610acb57604051631c78150b60e11b81526001600160a01b03871660048201526000805160206124c6833981519152602482015260440161093a565b610ad4876110ed565b610b186040518060400160405280600681526020016578556e69747960d01b815250604051806040016040528060048152602001637855545960e01b815250611141565b610b20611153565b610b2861115b565b610b406000805160206124c68339815191528761116b565b50856001600160a01b0316876001600160a01b03167fc434cb86100b6dee9ef2aeeab00a0bec6213374bcd578495019a7b6271d6f6fe60405160405180910390a38315610bc757845460ff60401b19168555604051600181527fc7f505b2f371ae2175ee4913f4499e1f2633a7b5936321eed1cdaeb6115181d29060200160405180910390a15b50505050505050565b610bd86111e2565b610be182611287565b61089882826112ca565b6000610bf5611387565b5060008051602061242683398151915290565b6000610c1381610f2b565b610898826113d0565b6000610c2781610f2b565b61089882611443565b6000805160206124c6833981519152610c4881610f2b565b61096083836114b3565b6000610c5d81610f2b565b6108256114c8565b6000805160206124a6833981519152546001600160a01b031690565b6000610c8b610c65565b905090565b6000918252600080516020612466833981519152602090815260408084206001600160a01b0393909316845291905290205460ff1690565b7f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace048054606091600080516020612406833981519152916107769061222b565b6000805160206124a683398151915254600090600160d01b900465ffffffffffff166000805160206124468339815191528115801590610d4f57504265ffffffffffff831610155b610d5b57600080610d71565b6001810154600160a01b900465ffffffffffff16825b92509250509091565b600033610808818585610fa9565b6000805160206124a68339815191525460009060008051602061244683398151915290600160d01b900465ffffffffffff168015801590610dd057504265ffffffffffff8216105b610dea578154600160d01b900465ffffffffffff16610dff565b6001820154600160a01b900465ffffffffffff165b9250505090565b6000610e10610e46565b509050336001600160a01b03821614610e3e57604051636116401160e11b815233600482015260240161093a565b610825611511565b600080516020612446833981519152546001600160a01b03811691600160a01b90910465ffffffffffff1690565b81610e9257604051631fe1e13d60e11b815260040160405180910390fd5b61089882826115ae565b6000610ea781610f2b565b6108256115ca565b6001600160a01b0391821660009081527f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace016020908152604080832093909416825291909152205490565b60006001600160e01b031982166318a4c3c360e11b14806107315750610731826115d5565b610960838383600161160a565b61082581336116f2565b610f4060008061172b565b565b6000610f4e8484610eaf565b9050600019811015610fa35781811015610f9457604051637dc7a0d960e11b81526001600160a01b0384166004820152602481018290526044810183905260640161093a565b610fa38484848403600061160a565b50505050565b6001600160a01b038316610fd357604051634b637e8f60e11b81526000600482015260240161093a565b6001600160a01b038216610ffd5760405163ec442f0560e01b81526000600482015260240161093a565b610960838383611806565b6110118261084e565b61101a81610f2b565b610fa3838361116b565b6001600160a01b038116331461104d5760405163334bd91960e11b815260040160405180910390fd5b6109608282611811565b61105f61186a565b600080516020612486833981519152805460ff191681557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516001600160a01b03909116815260200160405180910390a150565b6001600160a01b0382166110e15760405163ec442f0560e01b81526000600482015260240161093a565b61089860008383611806565b6110f561189a565b6001600160a01b03811661112e57604051631c78150b60e11b81526001600160a01b03821660048201526000602482015260440161093a565b6111396000826118e3565b610825611153565b61114961189a565b61089882826118f5565b610f4061189a565b61116361189a565b610f40611946565b6000600080516020612446833981519152836111d057600061118b610c65565b6001600160a01b0316146111b257604051631fe1e13d60e11b815260040160405180910390fd5b6001810180546001600160a01b0319166001600160a01b0385161790555b6111da8484611967565b949350505050565b306001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016148061126957507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031661125d600080516020612426833981519152546001600160a01b031690565b6001600160a01b031614155b15610f405760405163703e46dd60e11b815260040160405180910390fd5b600061129281610f2b565b6040516001600160a01b038316907f6b70829fcbe4891157f7a7496f9870927de3c8237adbe9cd39bae09b7382c40990600090a25050565b816001600160a01b03166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa925050508015611324575060408051601f3d908101601f1916820190925261132191810190612265565b60015b61134c57604051634c9c8ce360e01b81526001600160a01b038316600482015260240161093a565b600080516020612426833981519152811461137d57604051632a87526960e21b81526004810182905260240161093a565b6109608383611a0c565b306001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610f405760405163703e46dd60e11b815260040160405180910390fd5b60006113da610d88565b6113e342611a62565b6113ed9190612294565b90506113f98282611a99565b60405165ffffffffffff821681526001600160a01b038316907f3377dc44241e779dd06afab5b788a35ca5f3b778836e2990bdb26a2a4b2e5ed69060200160405180910390a25050565b600061144e82611b26565b61145742611a62565b6114619190612294565b905061146d828261172b565b6040805165ffffffffffff8085168252831660208201527ff1038c18cf84a56e432fdbfaf746924b7ea511dfe03a6506a0ceba4888788d9b910160405180910390a15050565b6114be823383610f42565b6108988282611b6e565b6114d0611ba4565b600080516020612486833981519152805460ff191660011781557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a25833611099565b60008051602061244683398151915260008061152b610e46565b915091506115408165ffffffffffff16151590565b158061155457504265ffffffffffff821610155b1561157c576040516319ca5ebb60e01b815265ffffffffffff8216600482015260240161093a565b61158e6000611589610c65565b611811565b5061159a60008361116b565b505081546001600160d01b03191690915550565b6115b78261084e565b6115c081610f2b565b610fa38383611811565b610f40600080611a99565b60006001600160e01b03198216637965db0b60e01b148061073157506301ffc9a760e01b6001600160e01b0319831614610731565b6000805160206124068339815191526001600160a01b0385166116435760405163e602df0560e01b81526000600482015260240161093a565b6001600160a01b03841661166d57604051634a1406b160e11b81526000600482015260240161093a565b6001600160a01b038086166000908152600183016020908152604080832093881683529290522083905581156116eb57836001600160a01b0316856001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925856040516116e291815260200190565b60405180910390a35b5050505050565b6116fc8282610c90565b6108985760405163e2517d3f60e01b81526001600160a01b03821660048201526024810183905260440161093a565b6000805160206124a68339815191525460008051602061244683398151915290600160d01b900465ffffffffffff1680156117c8574265ffffffffffff8216101561179e57600182015482546001600160d01b0316600160a01b90910465ffffffffffff16600160d01b021782556117c8565b6040517f2b1fa2edafe6f7b9e97c1a9e0c3660e645beb2dcaa2d45bdbf9beaf5472e1ec590600090a15b5060010180546001600160a01b0316600160a01b65ffffffffffff948516026001600160d01b031617600160d01b9290931691909102919091179055565b610960838383611bd5565b6000600080516020612446833981519152831580156118485750611833610c65565b6001600160a01b0316836001600160a01b0316145b15611860576001810180546001600160a01b03191690555b6111da8484611be8565b6000805160206124868339815191525460ff16610f4057604051638dfc202b60e01b815260040160405180910390fd5b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a0054600160401b900460ff16610f4057604051631afcd79f60e31b815260040160405180910390fd5b6118eb61189a565b6108988282611c64565b6118fd61189a565b6000805160206124068339815191527f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace0361193784826122f9565b5060048101610fa383826122f9565b61194e61189a565b600080516020612486833981519152805460ff19169055565b60006000805160206124668339815191526119828484610c90565b611a02576000848152602082815260408083206001600160a01b03871684529091529020805460ff191660011790556119b83390565b6001600160a01b0316836001600160a01b0316857f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a46001915050610731565b6000915050610731565b611a1582611ccd565b6040516001600160a01b038316907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b90600090a2805115611a5a576109608282611d32565b610898611da8565b600065ffffffffffff821115611a95576040516306dfcc6560e41b8152603060048201526024810183905260440161093a565b5090565b6000805160206124468339815191526000611ab2610e46565b835465ffffffffffff8616600160a01b026001600160d01b03199091166001600160a01b038816171784559150611af290508165ffffffffffff16151590565b15610fa3576040517f8886ebfc4259abdbc16601dd8fb5678e54878f47b3c34836cfc51154a960510990600090a150505050565b600080611b31610d88565b90508065ffffffffffff168365ffffffffffff1611611b5957611b5483826123b8565b610847565b61084765ffffffffffff841662069780611dc7565b6001600160a01b038216611b9857604051634b637e8f60e11b81526000600482015260240161093a565b61089882600083611806565b6000805160206124868339815191525460ff1615610f405760405163d93c066560e01b815260040160405180910390fd5b611bdd611ba4565b610960838383611dd7565b6000600080516020612466833981519152611c038484610c90565b15611a02576000848152602082815260408083206001600160a01b0387168085529252808320805460ff1916905551339287917ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9190a46001915050610731565b611c6c61189a565b6000805160206124468339815191526001600160a01b038216611ca557604051636116401160e11b81526000600482015260240161093a565b80546001600160d01b0316600160d01b65ffffffffffff851602178155610fa360008361116b565b806001600160a01b03163b600003611d0357604051634c9c8ce360e01b81526001600160a01b038216600482015260240161093a565b60008051602061242683398151915280546001600160a01b0319166001600160a01b0392909216919091179055565b6060600080846001600160a01b031684604051611d4f91906123d6565b600060405180830381855af49150503d8060008114611d8a576040519150601f19603f3d011682016040523d82523d6000602084013e611d8f565b606091505b5091509150611d9f858383611f15565b95945050505050565b3415610f405760405163b398979f60e01b815260040160405180910390fd5b6000828218828410028218610847565b6000805160206124068339815191526001600160a01b038416611e135781816002016000828254611e0891906123f2565b90915550611e859050565b6001600160a01b03841660009081526020829052604090205482811015611e665760405163391434e360e21b81526001600160a01b0386166004820152602481018290526044810184905260640161093a565b6001600160a01b03851660009081526020839052604090209083900390555b6001600160a01b038316611ea3576002810180548390039055611ec2565b6001600160a01b03831660009081526020829052604090208054830190555b826001600160a01b0316846001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef84604051611f0791815260200190565b60405180910390a350505050565b606082611f2557611b5482611f6c565b8151158015611f3c57506001600160a01b0384163b155b15611f6557604051639996b31560e01b81526001600160a01b038516600482015260240161093a565b5080610847565b805115611f7c5780518082602001fd5b60405163d6bda27560e01b815260040160405180910390fd5b600060208284031215611fa757600080fd5b81356001600160e01b03198116811461084757600080fd5b60005b83811015611fda578181015183820152602001611fc2565b50506000910152565b6020815260008251806020840152612002816040850160208701611fbf565b601f01601f19169190910160400192915050565b80356001600160a01b038116811461202d57600080fd5b919050565b6000806040838503121561204557600080fd5b61204e83612016565b946020939093013593505050565b60008060006060848603121561207157600080fd5b61207a84612016565b925061208860208501612016565b929592945050506040919091013590565b6000602082840312156120ab57600080fd5b5035919050565b600080604083850312156120c557600080fd5b823591506120d560208401612016565b90509250929050565b600080604083850312156120f157600080fd5b6120fa83612016565b91506120d560208401612016565b634e487b7160e01b600052604160045260246000fd5b6000806040838503121561213157600080fd5b61213a83612016565b9150602083013567ffffffffffffffff81111561215657600080fd5b8301601f8101851361216757600080fd5b803567ffffffffffffffff81111561218157612181612108565b604051601f8201601f19908116603f0116810167ffffffffffffffff811182821017156121b0576121b0612108565b6040528181528282016020018710156121c857600080fd5b816020840160208301376000602083830101528093505050509250929050565b6000602082840312156121fa57600080fd5b61084782612016565b60006020828403121561221557600080fd5b813565ffffffffffff8116811461084757600080fd5b600181811c9082168061223f57607f821691505b60208210810361225f57634e487b7160e01b600052602260045260246000fd5b50919050565b60006020828403121561227757600080fd5b5051919050565b634e487b7160e01b600052601160045260246000fd5b65ffffffffffff81811683821601908111156107315761073161227e565b601f82111561096057806000526020600020601f840160051c810160208510156122d95750805b601f840160051c820191505b818110156116eb57600081556001016122e5565b815167ffffffffffffffff81111561231357612313612108565b61232781612321845461222b565b846122b2565b6020601f82116001811461235b57600083156123435750848201515b600019600385901b1c1916600184901b1784556116eb565b600084815260208120601f198516915b8281101561238b578785015182556020948501946001909201910161236b565b50848210156123a95786840151600019600387901b60f8161c191681555b50505050600190811b01905550565b65ffffffffffff82811682821603908111156107315761073161227e565b600082516123e8818460208701611fbf565b9190910192915050565b808201808211156107315761073161227e56fe52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace00360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbceef3dac4538c82c8ace4063ab0acd2d15cdb5883aa1dff7c2673abb3d869840002dd7bc7dec4dceedda775e58dd541e08a116c6c53815c0bd028192f7b626800cd5ed15c6e187e77e9aee88184c21f4f2182ab5827cb3b7e07fbedcd63f03300eef3dac4538c82c8ace4063ab0acd2d15cdb5883aa1dff7c2673abb3d8698401250521c8bc13142051ff7835504c7eb5922d766cdc38798c64357ab72c032434a2646970667358221220c0c24a80fb8a2ccf539df3aeb990a22c3bae820f1d12fa284f817586c8d42f8d64736f6c634300081d0033";
const isSuperArgs = (xs) => xs.length > 1;
export class XUnity__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
XUnity__factory.bytecode = _bytecode;
XUnity__factory.abi = _abi;
//# sourceMappingURL=XUnity__factory.js.map